import React, { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import { Api } from "../../api/Api";
import { Link as RouterLink } from "react-router-dom";
import { UrlPathCustomerDetails } from "../../api/url";

const customerNameCache: { [customerNumber: string]: string } = {};
const inflightCustomerRequests: { [customerNumber: string]: Promise<any> } = {};

const CustomerNameCell: React.FC<{ customerNumber: string }> = ({ customerNumber }) => {
  const [name, setName] = useState<string>("");
  useEffect(() => {
    let isMounted = true;
    if (customerNumber) {
      if (customerNameCache[customerNumber]) {
        setName(customerNameCache[customerNumber]);
      } else {
        if (!inflightCustomerRequests[customerNumber]) {
          inflightCustomerRequests[customerNumber] = Api.findCustomer(customerNumber)
            .then((customer) => {
              const displayName =
                customer.firstName && customer.lastName
                  ? `${customer.firstName} ${customer.lastName}`
                  : customer.mailAddress || customer.externalCustomerId || customerNumber;
              customerNameCache[customerNumber] = displayName;
              return customer;
            })
            .catch(() => {
              customerNameCache[customerNumber] = customerNumber;
              return undefined;
            })
            .finally(() => {
              delete inflightCustomerRequests[customerNumber];
            });
        }
        inflightCustomerRequests[customerNumber]
          .then((customer) => {
            if (isMounted && customer) {
              const displayName =
                customer.firstName && customer.lastName
                  ? `${customer.firstName} ${customer.lastName}`
                  : customer.mailAddress || customer.externalCustomerId || customerNumber;
              setName(displayName);
            } else if (isMounted && customerNameCache[customerNumber]) {
              setName(customerNameCache[customerNumber]);
            }
          })
          .catch(() => {
            if (isMounted) {
              setName(customerNumber);
            }
          });
      }
    }
    return () => {
      isMounted = false;
    };
  }, [customerNumber]);
  return name ? (
    <Tooltip title={customerNumber}>
      <span>
        <RouterLink
          to={UrlPathCustomerDetails.replace(":id", customerNumber)}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {name}
        </RouterLink>
      </span>
    </Tooltip>
  ) : null;
};

export default CustomerNameCell;
